(() => {
  const initialize = (dialog) => {
    if (dialog.dataset.lmbPalmaReady === 'true') return;
    dialog.dataset.lmbPalmaReady = 'true';
    const section = dialog.closest('[data-section-type="product"]');
    const trigger = section?.querySelector('[data-lmb-bis-trigger]');
    const triggerWrap = section?.querySelector('[data-lmb-bis-trigger-wrap]');
    const form = dialog.querySelector('[data-lmb-bis-form]');
    const email = dialog.querySelector('[data-lmb-bis-email]');
    const quantity = dialog.querySelector('[data-lmb-bis-quantity]');
    const body = dialog.querySelector('[data-lmb-bis-body]');
    const variantField = form?.querySelector('[name="contact[Variante ID]"]');
    const feedback = dialog.querySelector('[data-lmb-bis-feedback]');
    let previousFocus;

    const open = () => {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      (feedback || email || dialog.querySelector('[data-lmb-bis-close]'))?.focus();
    };
    const close = () => {
      if (!dialog.open) return;
      dialog.close();
      if (previousFocus?.isConnected) previousFocus.focus();
    };

    trigger?.addEventListener('click', open);
    dialog.querySelector('[data-lmb-bis-close]')?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    if (window.themeCore?.EventBus && section?.dataset.sectionId) {
      window.themeCore.EventBus.listen('pdp:section-' + section.dataset.sectionId + ':change-variant', ({ variant }) => {
        if (!variant || !triggerWrap) return;
        const unavailable = variant.available === false && variant.inventory_policy !== 'continue';
        triggerWrap.classList.toggle('is-hidden', !unavailable);
        if (variantField) variantField.value = String(variant.id);
        dialog.dataset.variantId = String(variant.id);
        if (!unavailable) close();
      });
    }

    form?.addEventListener('submit', (event) => {
      if (!form.reportValidity()) {
        event.preventDefault();
        return;
      }
      if (body && quantity && email) {
        body.value = [
          'Verfügbarkeitsanfrage / availability request',
          'Produkt / Product: ' + dialog.dataset.productName,
          'Produktlink / Product URL: ' + dialog.dataset.productUrl,
          'Variante ID / Variant ID: ' + (variantField?.value || dialog.dataset.variantId),
          'Gewünschte Anzahl / Quantity: ' + quantity.value,
          'E-Mail / Email: ' + email.value.trim(),
          'Bitte persönlich antworten. Keine automatische Lagerbenachrichtigung.'
        ].join('\n');
      }
      // Shopify's contact form may open an hCaptcha challenge in the page layer.
      // Close this native dialog so the challenge stays visible and operable.
      dialog.close();
    });

    if (feedback) open();
  };

  const initializeAll = (root = document) => root.querySelectorAll('[data-lmb-palma-notify]').forEach(initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
